"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadScript = (url) => new Promise((resolve) => {
    const element = document.createElement("script");
    element.setAttribute("src", url);
    element.addEventListener("load", resolve);
    document.body.append(element);
});
exports.default = loadScript;
